export default "__VITE_ASSET__PcIIGOKJ__"